import React from "react";
import { useTranslation } from "react-i18next";
import { ContentsItemContainer } from "../../components/SideContents";
import { SideContents } from "../../components/SideContents";
import "./index.less";
const CloudOringinalBody = () => {
  const { t } = useTranslation();
  const navList = [
    { key: "cloud-step1", label: t("cloudOriginal.side-content.item1") },
    { key: "cloud-step2", label: t("cloudOriginal.side-content.item2") },
    {
      key: "cloud-step3",
      label: t("cloudOriginal.side-content.item3"),
      children: [
        { key: "cloud-step4", label: t("cloudOriginal.side-content.item4") },
        { key: "cloud-step5", label: t("cloudOriginal.side-content.item5") },
        { key: "cloud-step6", label: t("cloudOriginal.side-content.item6") },
      ],
    },
  ];
  return (
    <div className="cloud-original-intainer">
      <div className="left-box">
        <SideContents navList={navList} />
      </div>
      <div className="right-box">
        <ContentsItemContainer id="cloud-step1">
          <div className="title">
            <h1 className="clh1">{t("cloudOriginal.item1.title")}</h1>
            <div className="title-content">
              <div className="">{t("cloudOriginal.item1.content1")}</div>
              <div className="strong">{t("cloudOriginal.item1.content2")}</div>
            </div>
          </div>
          <div className="content">
            {Array.apply(null, Array(4)).map((item, index) => (
              <div className="card" key={index}>
                <div className="card-icon-box" style={{}}>
                  <img
                    src={`https://files.authing.co/authing-website/cloud-original-icon${index}.png`}
                    alt="authing"
                    className="card-icon"
                  />
                </div>
                <div className="card-title">
                  {t(`cloudOriginal.item1.cardData.${index}.title`)}
                </div>
                <div className="card-content">
                  {t(`cloudOriginal.item1.cardData.${index}.content`)}
                </div>
              </div>
            ))}
          </div>
        </ContentsItemContainer>
        <ContentsItemContainer id="cloud-step2">
          <div className="title">
            <h1 className="clh1">{t(`cloudOriginal.item2.title`)}</h1>
            <div className="title-content">
              {t(`cloudOriginal.item2.content`)}
            </div>
            {Array.apply(null, Array(3)).map((item, index) => (
              <li key={"li" + index}>
                {t(`cloudOriginal.item2.liData.${index}`)}
              </li>
            ))}
            <div className="item2-img">
              <img
                style={{ maxHeight: "100%", maxWidth: "100%" }}
                src={t(`cloudOriginal.item2.img`)}
                alt="云原生技术发展"
              />
            </div>
          </div>
        </ContentsItemContainer>
        <ContentsItemContainer id="cloud-step3">
          <div className="title">
            <h1 className="clh1">{t(`cloudOriginal.item3.title`)}</h1>
            <ContentsItemContainer id="cloud-step4">
              <h1 className="clh2">{t(`cloudOriginal.item3.subTitle1`)}</h1>
              <div className="title-content">
                {t(`cloudOriginal.item3.subContent1`)}
              </div>
              <div className="item3-img-1">
                <img
                  src="https://files.authing.co/authing-website/puilc-cloud-base.png"
                  style={{ width: "100%" }}
                  alt="公有云基础设施"
                />
              </div>
              <div className="title-content">
                {t(`cloudOriginal.item3.subContent11`)}
              </div>
              <div className="item3-img-11">
                <img
                  src="https://files.authing.co/authing-website/cloud-native-base4.jpg"
                  style={{ width: "100%" }}
                  alt="authing"
                />
              </div>
              <div className="title-content">
                {t(`cloudOriginal.item3.subContent111`)}
              </div>
            </ContentsItemContainer>
            <ContentsItemContainer id="cloud-step5">
              <h1 className="clh2 clh2-top">
                {t(`cloudOriginal.item3.subTitle2`)}
              </h1>
              <div className="title-content">
                {t(`cloudOriginal.item3.subContent2`)}
              </div>
              <div className="item3-img-2">
                <img
                  src={t(`cloudOriginal.item3.subContentImg2`)}
                  style={{ width: "100%" }}
                  alt="Kubernetes容器化"
                />
              </div>
            </ContentsItemContainer>
            <ContentsItemContainer id="cloud-step6">
              <h1 className="clh2">{t(`cloudOriginal.item3.subTitle3`)}</h1>
              <div className="title-content">
                {t(`cloudOriginal.item3.subContent3`)}
              </div>
              <div className="item3-img-2">
                <img
                  src={t(`cloudOriginal.item3.subContentImg3`)}
                  //   src="https://files.authing.co/authing-website/cloud-center.png"
                  style={{ width: "100%" }}
                  alt="云原生中立"
                />
              </div>
              <div className="title-content content-bottom">
                {t(`cloudOriginal.item3.subContent4`)}
              </div>
            </ContentsItemContainer>
          </div>
        </ContentsItemContainer>
      </div>
    </div>
  );
};

export default CloudOringinalBody;
